document.addEventListener('DOMContentLoaded', function () {
    const thumbnailsMediaLength = document.querySelectorAll('.pdp-thumb-media').length;  
    let thumbLoop = true;
    
    if (thumbnailsMediaLength <= 5) {
      thumbLoop = false;
    }

    if (thumbnailsMediaLength > 1) {
      /*document.querySelector('.noos-pdp-media-wrapper .noos-badge-label').classList.add('badge__label_position');*/
      const badgeLabelElement = document.querySelector('.noos-pdp-media-wrapper .noos-badge-label');
      if (badgeLabelElement) {
        badgeLabelElement.classList.add('badge__label_position');
      }
    } 

    if (thumbnailsMediaLength > 5){
      document.querySelector('.noos-slider-next').classList.add('show');
    } else {
      document.querySelector('.noos-slider-next').classList.add('hide');
    }
    const nextButton = document.querySelector('.noos-slider-next');
    if (thumbnailsMediaLength > 1) { 
      let productNavSwiper = new Swiper('.noos-pdp-media-thumbnail', {
        slidesPerView: 5,
        direction: 'vertical',
        spaceBetween: 12,
        loop: thumbLoop,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextButton,
        },
      });
  
      let productSwiper = new Swiper('.noos-pdp-media', {
        slidesPerView: 1.1,
        spaceBetween: 5,
        loop: true,
        thumbs: {
          swiper: productNavSwiper,
        },
        breakpoints: {
          989: {
            slidesPerView: 1,
            spaceBetween: 1,
          },
        },
      });
    }   
    
    // Function to initialize the zoom effect
    function initZoomEffect() {
      const swiperContainer = document.querySelector('.noos-pdp-media');
      const zoomedImage = document.querySelector('.zoomed-image');
      const zoomContainer = document.querySelector('.zoom-container');

      // Remove existing event listeners if any (cleanup before adding new ones)
      swiperContainer.removeEventListener('mousemove', handleMouseMove);
      swiperContainer.removeEventListener('mouseleave', handleMouseLeave);

      // Add event listeners for zoom effect only if window size is greater than 989px
      if (window.innerWidth > 989) {
          swiperContainer.addEventListener('mousemove', handleMouseMove);
          swiperContainer.addEventListener('mouseleave', handleMouseLeave);
      }

      function handleMouseMove(e) {
          let mainImage = e.target.closest('.swiper-slide-active img, .swiper-slide-duplicate-active img');
          if (!mainImage) {
              // Check for a single image case
              mainImage = e.target.closest('.noos-pdp-media img');
          }
          if (!mainImage) return;

          const bounds = mainImage.getBoundingClientRect();
          const x = e.clientX - bounds.left;
          const y = e.clientY - bounds.top;

          // Show the zoom container and update the zoomed image source
          zoomContainer.style.display = 'block';
          zoomedImage.src = mainImage.src;

          // Calculate the scale for the background image
          const scale = 3; // Set the zoom scale
          const xPercent = (x / bounds.width) * 100;
          const yPercent = (y / bounds.height) * 100;

          // Apply the scale transformation to zoom in
          zoomedImage.style.transform = `scale(${scale})`;
          zoomedImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      }

      function handleMouseLeave() {
          zoomContainer.style.display = 'none'; // Hide the zoom container on mouse leave
      }
    }
    // Initialize the zoom effect on page load
    initZoomEffect();
    // Add an event listener to handle window resizing
    window.addEventListener('resize', function() {
      initZoomEffect(); // Re-initialize zoom effect when window is resized
    });
});